


























































































import { Component, Prop, Vue } from "vue-property-decorator";
import PemantauanAnestesiStepper from "./PemantauanAnestesiStepper.vue";
import { storePemantauanAnestesi } from "@/store/modules/PemantauanAnestesiStore";
import PemantauanAnestesiSvc from "@/services/PemantauanAnestesiService";
import { appModule } from "@/store/modules/app";
import moment from "moment";

@Component({
  components: {
    PemantauanAnestesiStepper,
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class PemantauanAnestesiList extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;

  showForm = false;
  showDetail = false;
  selectedItem: any = null;
  editData: any = null;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  tableHeaders = [
    { text: "Tanggal", value: "tanggal", width: "100px" },
    { text: "Jenis Pembedahan", value: "jenis_pembedahan" },
    { text: "ASA", value: "asa_status", width: "90px" },
    { text: "Anestesi", value: "jenis_anestesi", width: "120px" },
    { text: "Durasi Op", value: "durasi", width: "110px", sortable: false },
    { text: "Status", value: "status", width: "130px", sortable: false },
    { text: "Aksi", value: "actions", sortable: false, width: "150px" },
  ];

  mounted() {
    storePemantauanAnestesi.getByRegister(this.register);
  }

  get storeAnestesi() {
    return storePemantauanAnestesi;
  }

  get items() {
    return storePemantauanAnestesi.items;
  }

  asaColor(asa: string) {
    if (["3", "4", "5", "6", "E"].includes(asa)) return "red";
    if (asa === "2") return "orange";
    return "green";
  }

  formatDate(date: string) {
    return date ? moment(date).format("DD-MM-YYYY") : "-";
  }

  tambah() {
    this.editData = null;
    this.showDetail = false;
    this.showForm = true;
  }

  edit(item: any) {
    this.editData = item;
    this.showDetail = false;
    this.showForm = true;
  }

  lihat(item: any) {
    this.editData = item;
    this.showForm = false;
    this.showDetail = true;
  }

  cancelForm() {
    this.showForm = false;
    this.showDetail = false;
    this.editData = null;
    storePemantauanAnestesi.getByRegister(this.register);
  }

  onSaved() {
    this.showForm = false;
    this.showDetail = false;
    this.editData = null;
    storePemantauanAnestesi.getByRegister(this.register);
  }

  cetakPdf(item: any) {
    PemantauanAnestesiSvc.printPdf(item.id);
  }

  async hapus(item: any) {
    const q = confirm("Anda yakin akan menghapus pemantauan anestesi ini?");
    if (q) {
      try {
        const resp = await PemantauanAnestesiSvc.destroy(item.id);
        if (resp?.data?.status == "1") {
          appModule.NoticeDelay("Berhasil menghapus");
          storePemantauanAnestesi.getByRegister(this.register);
        }
      } catch {
        // handled by service
      }
    }
  }
}
